// @flow
import type { Node } from 'react';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import BackgroundColor from 'components/common/BackgroundColor';
import Responsive from 'components/common/Responsive';

import './ResetTemplate.scss';

type Props = {
  form: Node,
};

class ResetTemplate extends Component<Props> {
  render() {
    const { form } = this.props;
    return (
      <div className="reset-template">
        <BackgroundColor color="#fbfbfb" />
        <Responsive className="mock-header">
          <Link to="/" className="brand">
            <img src="https://images.cacheby.com/logo.svg" alt="CacheBy" />
          </Link>
        </Responsive>
        <section className="rest">
          <div className="reset-card">{form}</div>
        </section>
      </div>
    );
  }
}

export default ResetTemplate;



// WEBPACK FOOTER //
// ./src/components/reset/ResetTemplate/ResetTemplate.js